/**
 * Format a date to dd-mm-yyyy
 * @param date Date in string, Date or number format
 * @param options.defaultValue A default value when empty ('')
 * @param options.includeTime Also shows the time
 */
export function toDutchDate(
  date: string | number | undefined | null | Date,
  options: {
    defaultValue?: string;
    includeTime?: boolean;
  } = {
    defaultValue: '',
    includeTime: false,
  },
): string {
  const localeOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  if (!date || date === null || date === '' || date === 0) {
    return options.defaultValue || '';
  }
  if (options.includeTime) {
    return new Date(date).toLocaleTimeString('nl-NL', localeOptions);
  }
  return new Date(date).toLocaleDateString('nl-NL', localeOptions);
}
